import * as React from 'react';
//import { setOpenDocument } from '../../store/reducers/documentViewerReducer';
import { Viewer } from '../docViewer/viewer';
import { IconsPreview } from '../docViewer/assets/iconsPreview';

export function SandboxDev() {
    //const classes = useStyles();
    const queryParams = new URLSearchParams(window.location.search);
    const [catalogId, setCatalogId] = React.useState('');
    //D777359M

    // dispatch(
    //     setOpenDocument({
    //         viewerId: 'viewer_0',
    //         doc: {
    //             id: 'mockDoc1',
    //             catalog: 'MOCK_D9010020',
    //             originalFilename: 'mockFile',
    //             path: 'path',
    //             filePath: 'fPath',
    //             externalId: '6936e197479110317ae52e00',
    //             type: {
    //                 name: 'type_other',
    //                 tabs: [
    //                     {
    //                         _id: 'tab_0',
    //                         name: 'tab_other',
    //                         sortOrder: 0,
    //                         isAlerts: false,
    //                         isCorrespondence: false,
    //                         isVirtual: false,
    //                         isERS: false,
    //                         groupingStatus: [],
    //                         thumbDisplay: 'string',
    //                     },
    //                 ],
    //                 isEReferral: true,
    //             },
    //             metadata: {
    //                 breakGlassRole: 'CAN_BREAKGLASS_LV_1',
    //                 contentType: 'application/pdf',
    //                 hidden: false,
    //                 hiddenPages: '[]',
    //                 originalFilename: 'test.pdf',
    //                 version: 29,
    //                 pageCount: 10,
    //             },
    //             bookmarks: [],
    //             repositoryId: 'SRC_UNITYSTORE',
    //             requiresBreakGlass: false,
    //             specialty: null,
    //             specialtyCode: '-',
    //             startDate: '2025-12-08T14:33:00.000+00:00',
    //             totalComments: 0,
    //             docKind: 'DOCUMENT',
    //         },
    //     }),
    // );

    const [test, setTest] = React.useState('viewer');

    React.useEffect(() => {
        const qpCat = queryParams.get('catalog');
        const test = queryParams.get('test');
        if (qpCat !== null) {
            setCatalogId(qpCat);
        } else {
            setCatalogId('');
        }
        if (test !== null) {
            setTest(test);
        } else {
            setTest('viewer');
        }
    }, [queryParams]);

    return (
        <div style={{ height: '100%' }}>
            {test === 'viewer' && <Viewer catalogId={catalogId} />}

            {test === 'icons' && <IconsPreview />}
        </div>
    );
}
